'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isFlexSupported;
function isFlexSupported() {
    if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
        var documentElement = window.document.documentElement;

        return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
    }
    return false;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/_util/isFlexSupported.js
// module id = 932
// module chunks = 0